import { SVGProps, Ref, forwardRef } from 'react';

export const DrawerOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.75 1C2.567 1 1.4 2.905.72 8.089.04 13.272.875 15 4.059 15h7.882c3.184 0 4.018-1.728 3.34-6.911C14.6 2.905 13.432 1 10.25 1zM2.108 8.27c.339-2.583.774-4.052 1.34-4.875.258-.374.534-.598.85-.743.334-.152.79-.252 1.452-.252h4.5c.661 0 1.118.1 1.451.252.317.145.593.37.85.743.567.823 1.002 2.292 1.341 4.876l.045.36H10.68l-.5 1.333H5.817l-.5-1.333H2.063zm-.177 1.761q-.045.715-.025 1.273c.03.79.151 1.277.295 1.575.126.26.277.401.495.504.257.12.676.217 1.363.217h7.882c.687 0 1.106-.096 1.363-.217a.98.98 0 0 0 .495-.504c.144-.298.266-.786.295-1.575q.02-.558-.025-1.273h-2.42l-.5 1.333H4.847l-.5-1.333z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DrawerOutlinedSize16Glyph.displayName = 'DrawerOutlinedSize16Glyph';
